import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox } from '_components';
import styles from './Templates.module.css'


class PatientCareCenterNoteObjectiveTemplateCheckBox extends React.Component {


    handleTemplateClick() {
        if (this.props.checked) {
            this.props.removeTemplate(this.props.noteId, this.props.TENO)
        } else {
            this.props.addTemplate(this.props.noteId, this.props.TENO)
        }
    }

    render() {
        return (
            <CheckBox
                key={this.props.template.TENO}
                label={this.props.template.TENAME}
                className={styles.checkbox}
                checked={this.props.checked}
                onClick={() => this.handleTemplateClick()}
                disabled={this.props.prevoiuslyUsed}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        addTemplate: bindActionCreators(noteActions.addTemplate, dispatch),
        removeTemplate: bindActionCreators(noteActions.removeTemplate, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let type = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let entry = undefined;

    if (state.entities.notes.PTOBJECTIVETEMPLATESXREF !== undefined) {
        if (type === 1) {
            entry = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
                .find(x => state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBEVNO === pk &&
                    state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBTENO === ownprops.TENO);
        } else {
            entry = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
                .find(x => state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBNTNO === pk &&
                    state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBTENO === ownprops.TENO);
        }
    }
    return {
        noteId: noteId,
        template: state.entities.notes.PTOBJECTIVETEMPLATES[ownprops.TENO + '_' + noteId],
        checked: entry !== undefined ? true : false,
        prevoiuslyUsed: entry !== undefined ? state.entities.notes.PTOBJECTIVETEMPLATESXREF[entry].OBPREVIOUSLYUSED : false,
    };
}

const connectedPatientCareCenterNoteObjectiveTemplateCheckBox = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveTemplateCheckBox);
export { connectedPatientCareCenterNoteObjectiveTemplateCheckBox as PatientCareCenterNoteObjectiveTemplateCheckBox };

